<template>
  <div>
      <div class="detail">
          <div class="left">
              <div class="top">
                  <img :src="message.organizerLogo" alt="">
              </div>
              <div class="bottom">
                  <p>{{ message.organizerName}}</p>
              </div>
          </div>
          <div class="right">
              <p>{{ message.brief|convertTitle(100)}}</p>
          </div>
      </div>
      <div class="communityScroll">
             <div class="tab">
      <ul>
          <li @click="Meet"  v-bind:class="{ active: meet}">峰会</li>
          <li @click="Live" v-bind:class="{ active: live}">直播</li>
          <li @click="Video" v-bind:class="{active: video}">视频</li>
      </ul>
    </div>
      <div v-if="meet">
          <scroll-bar :url="'api/meeting/getMeetings?uid=' + newid +'&type='+ mytype +'&'"></scroll-bar>
      </div>

      <div v-if="live">
          <scroll-bar :url="'api/live/getLives?uid=' + newid +'&type='+ mytype +'&'"></scroll-bar>
      </div>
      <div v-if="video">
          <scroll-bar :url="'api/video/getvideos?uid=' + newid +'&type='+ mytype +'&'"></scroll-bar>
      </div>

      </div>

  </div>
</template>

<script>
  import api from 'api'
export default {
  data() {
    return {
      message: {},
      meet: true,
      live: false,
      video: false,
      newid: 0,
      mytype: "meet",
      api: 'api/'
    };
  },
  computed: {
    getCommunity() {
      return this.$store.state.community;
    }
  },
  created() {
    console.log(JSON.parse(this.$route.query.message))
    this.message = JSON.parse(this.$route.query.message)
    this.newid = this.$route.query.id;
    console.log(this.newid);
  },
  mounted() {
    this.first = true;
    // this.getShareInfo()
    this.initData()
  },
  methods: {
    // 初始化
    async initData() {
      const params = {
        targetType: 'hotorg',
        targetId: this.$route.query.id
      }
      const res = await api.common.getShareData(params)
      console.log('后台返回', res)
      this.getShareInfo(true, res.data.shareTitle, res.data.shareDesc, res.data.shareImg)
    },
    Meet() {
      this.meet = true;
      this.live = false;
      this.video = false;
      this.mytype = "meet";
    },
    Live() {
      this.meet = false;
      this.live = true;
      this.video = false;
      this.mytype = "live";
    },
    Video() {
      this.meet = false;
      this.live = false;
      this.video = true;
      this.mytype = "video";
    }
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.detail {
  height: 3.35333rem;
  padding: 38px 40px 0 46px;
  box-sizing: border-box;
  background-image: -webkit-linear-gradient(to right, #3079ec, #003095);
  background-image: linear-gradient(to right, #3079ec, #003095);
  .left {
    width: 180px;
    float: left;
    margin-top: 32px;
    .top {
      width: 160px;
      height: 80px;
      background-color: #fff;
      padding: 6px 12px;
      img {
        width: 160px;
      }
    }
    .bottom {
      margin-top: 10px;
      width: 180px;
      text-align: center;
      font-size: 26px;
      font-weight: 700;
      border-top: none;
      color: #fff;
      font-weight: 400;

    }
  }
  .right {
    width: 420px;
    height: 140px;
    display: inline-block;
    margin-left: 32px;
    color: #fff;
    line-height: 32px;
  }
}
.tab ul {
  /* width: 750px; */
  padding: 9px 29px 0 29px;
  background-color: #f4f4f4;
  box-sizing: border-box;
  list-style: none;
  display: flex;
  background: #f3f5f2 url(./../../assets/img/dian_bg.png) repeat-x left bottom;
  li {
    width: 220px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    flex: 1;
    font-size: 26px;

  }
  .active {
    background: url(./../../assets/img/selectbg.png);
    background-size: 100%;
    z-index: 10;
  }
}
.communityScroll {
    position: absolute;
    top: 3.30666rem;
    right: 0;
    width: 750px;
}
</style>



// WEBPACK FOOTER //
// src/components/Community/CommunityDetail.vue